import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React from "react";
import { attachmentsTableCols } from "./attachmentsTableCols";
import { lightTable } from "../../../../../../../../../styles/muiProps";
import { useECSContext } from "../../../ecsContext";
import { Box, Button } from "@mui/material";
import NumberedTitle from "../../../Components/Title";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";

export default function AttachmentsTable() {
  const { mrqAttachments, setMrqAttachments } = useECSContext();
  const table = useMaterialReactTable({
    data: mrqAttachments,
    columns: attachmentsTableCols,
    ...lightTable,
    enableStickyHeader: true,
    enableEditing: true,
    editDisplayMode: "row",
    createDisplayMode: "row",

    enableRowActions: true,
    positionActionsColumn: "last",

    muiEditTextFieldProps: {
      variant: "standard",
      size: "small",
      fullWidth: true,
    },

    onEditingRowSave: ({ values, row, table }) => {
      setMrqAttachments((prev) =>
        prev.map((item, index) => (index === row.index ? values : item)),
      );
      table.setEditingRow(null);
    },

    onCreatingRowSave: ({ values, table }) => {
      setMrqAttachments((prev) => [...prev, values]);
      table.setCreatingRow(null);
    },

    muiTableContainerProps: { sx: { maxHeight: "400px" } },

    enableRowSelection: true,
  });

  const handleDeleteSelected = () => {
    const selectedRows = table.getSelectedRowModel().rows;

    setMrqAttachments((prev) =>
      prev.filter(
        (_, index) => !selectedRows.some((row) => row.index === index),
      ),
    );

    table.resetRowSelection();
  };

  return (
    <div style={{ marginTop: "5px", maxWidth: 1000 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <NumberedTitle number="3" title="Attachments" />

        <Box display="flex" gap={1}>
          <Button
            onClick={() => table.setCreatingRow(true)}
            variant="contained"
            startIcon={<AddBoxIcon />}
          >
            Add
          </Button>

          <Button
            variant="contained"
            startIcon={<DeleteIcon />}
            color="error"
            onClick={handleDeleteSelected}
            disabled={!table.getSelectedRowModel().rows.length}
          >
            Delete
          </Button>
        </Box>
      </Box>

      <MaterialReactTable table={table} />
    </div>
  );
}
